import { createStructuredSelector } from 'reselect'

import {
  MGMT_PROGRAM_LIST,
  MGMT_PROGRAM_LIST_SUCCESS,
  MGMT_PROGRAM_LIST_ERROR,
  MGMT_PROGRAM_PAGE_SET,
  MGMT_PROGRAM_ADD,
  MGMT_PROGRAM_ADD_SUCCESS,
  MGMT_PROGRAM_ADD_ERROR,
  MGMT_PROGRAM_ADD_CHANGE,
  MGMT_PROGRAM_DETAIL,
  MGMT_PROGRAM_DETAIL_SUCCESS,
  MGMT_PROGRAM_DETAIL_ERROR,
  MGMT_PROGRAM_UPDATE,
  MGMT_PROGRAM_UPDATE_SUCCESS,
  MGMT_PROGRAM_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'mgmt_program';

export const MgmtProgramList = (page, num_page, orderBy, filters) => ({
  type: MGMT_PROGRAM_LIST,
  payload: { page, num_page, orderBy, filters }
});
export const MgmtProgramListSuccess = (data) => ({ type: MGMT_PROGRAM_LIST_SUCCESS, payload: data });
export const MgmtProgramListError = (error) => ({ type: MGMT_PROGRAM_LIST_ERROR, payload: error });
export const MgmtProgramPageSet = (data) => ({ type: MGMT_PROGRAM_PAGE_SET, payload: data });
export const MgmtProgramAddChangeSet = (data) => ({ type: MGMT_PROGRAM_ADD_CHANGE, payload: data });
export const MgmtProgramAdd = (data) => ({ type: MGMT_PROGRAM_ADD, payload: data });
export const MgmtProgramAddSuccess = (message) => ({ type: MGMT_PROGRAM_ADD_SUCCESS, payload: message });
export const MgmtProgramAddError = (error) => ({ type: MGMT_PROGRAM_ADD_ERROR, payload: error });
export const MgmtProgramDetail = (data) => ({ type: MGMT_PROGRAM_DETAIL, payload: data });
export const MgmtProgramDetailSuccess = (data) => ({ type: MGMT_PROGRAM_DETAIL_SUCCESS, payload: data });
export const MgmtProgramDetailError = (error) => ({ type: MGMT_PROGRAM_DETAIL_ERROR, payload: error });
export const MgmtProgramUpdate = (data) => ({ type: MGMT_PROGRAM_UPDATE, payload: data });
export const MgmtProgramUpdateSuccess = (message) => ({ type: MGMT_PROGRAM_UPDATE_SUCCESS, payload: message.message });
export const MgmtProgramUpdateError = (error) => ({ type: MGMT_PROGRAM_UPDATE_ERROR, payload: error });

const mgmt_program = (state) => state[NAME];
export const MgmtProgramSelector = createStructuredSelector({ mgmt_program });
